import React from "react";
import { extractQuoteId, pick } from "../utils/fieldExtractors";

export default function TicketSummaryCard({ ticket, projectQuoteId, roomNames = [], projectIdOverride = "", projectNameOverride = "" }) {
  const hasTicket = Boolean(ticket);
  const id = hasTicket ? (pick(ticket, "Id") ?? pick(ticket, "id")) : undefined;
  const summary = hasTicket ? (pick(ticket, "Summary") ?? pick(ticket, "summary")) : undefined;
  const status = hasTicket ? (pick(ticket, "Status.Name") ?? pick(ticket, "status.name")) : undefined;
  const owner = hasTicket ? (pick(ticket, "Owner.Name") ?? pick(ticket, "owner.name")) : undefined;
  const company = hasTicket ? (pick(ticket, "Company.Name") ?? pick(ticket, "company.name")) : undefined;
  const project = hasTicket ? (pick(ticket, "Project.Name") ?? pick(ticket, "project.name")) : projectNameOverride;
  const quoteIdFromTicket = hasTicket ? extractQuoteId(ticket) : undefined;
  const displayedQuoteId = projectQuoteId || quoteIdFromTicket || "";
  const projectId = hasTicket ? (pick(ticket, "Project.Id") ?? pick(ticket, "project.id")) : projectIdOverride;

  return (
    <div className="st-card" style={{ display: "flex", flexDirection: "row", alignItems: "stretch" }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className="st-card-title">{hasTicket ? "Selected ticket" : "Project details"}</div>
        {hasTicket && (
          <div className="st-badges">
            {status && <span className="st-badge">{status}</span>}
            {owner && <span className="st-badge st-badge-muted">Owner: {owner}</span>}
            {company && <span className="st-badge st-badge-muted">{company}</span>}
          </div>
        )}
        <div className="st-grid">
          {hasTicket && (
            <>
              <div className="st-label">Ticket ID</div>
              <div>{id}</div>
              <div className="st-label">Summary</div>
              <div>{summary}</div>
            </>
          )}

          <div className="st-label">Quote #</div>
          <div>{displayedQuoteId || ""}</div>

          <div className="st-label">Project ID</div>
          <div>
            {projectId ?? "N/A"}
            {project && <span className="st-note">&nbsp;({project})</span>}
          </div>
        </div>
      </div>
      <div style={{ flex: 1, minWidth: 0, marginLeft: 16 }}>
        <div className="st-card-title" style={{ fontSize: 14 }}>Room Names</div>
        {roomNames.length === 0 ? (
          <div className="st-note">None found</div>
        ) : (
          <ul style={{ listStyle: "disc", paddingLeft: 20, margin: 0 }}>
            {roomNames.map(r => (
              <li key={r} style={{ lineHeight: "1.3em", padding: "2px 0" }}>{r}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
